import React, { useState, createContext, useContext } from 'react';
import ImageCropper from './ImageCropper';

export const MODAL_TYPES = {
    IMAGE_CROPPER: "IMAGE_CROPPER",

};

const MODAL_COMPONENTS: any = {
    [MODAL_TYPES.IMAGE_CROPPER]: ImageCropper,
};

type GlobalModalContext = {
    showModal: (modalType: string, modalProps?: any) => void;
    hideModal: () => void;
    store: any;
};

const initalState: GlobalModalContext = {
    showModal: () => { },
    hideModal: () => { },
    store: {},
};

const GlobalModalContext = createContext(initalState);
export const useGlobalModalContext = () => useContext(GlobalModalContext);

export const GlobalModal: React.FC<{}> = ({ children }) => {
    const [store, setStore] = useState<any>();
    const { modalType, modalProps }: any = store || {};

    const showModal = (modalType: string, modalProps: any = {}) => {

        setStore({
            ...store,
            modalType,
            modalProps,
        });
    };

    const hideModal = () => {
        setStore({
            ...store,
            modalType: null,
            modalProps: {},
        });
    };

    const renderComponent = () => {
        const ModalComponent = MODAL_COMPONENTS[modalType];
        if (!modalType || !ModalComponent) {
            return null;
        }
        return <ModalComponent id="global-modal" {...modalProps} />;
    };

    return (
        <GlobalModalContext.Provider value={{ store, showModal, hideModal }}>
            {renderComponent()}
            {children}
        </GlobalModalContext.Provider>
    );
};